export * from '@lexical/react/LexicalTableOfContentsPlugin'
